// src/actions/artistActions.js
import {
  FETCH_ARTIST_PROFILE_REQUEST,
  FETCH_ARTIST_PROFILE_SUCCESS,
  FETCH_ARTIST_PROFILE_FAILURE,
  UPDATE_ARTIST_PROFILE_REQUEST,
  UPDATE_ARTIST_PROFILE_SUCCESS,
  UPDATE_ARTIST_PROFILE_FAILURE,
} from "./types";

export const fetchArtistProfileRequest = (payload) => ({
  type: FETCH_ARTIST_PROFILE_REQUEST,
  payload,
});

export const fetchArtistProfileSuccess = (profile) => ({
  type: FETCH_ARTIST_PROFILE_SUCCESS,
  payload: profile,
});

export const fetchArtistProfileFailure = (error) => ({
  type: FETCH_ARTIST_PROFILE_FAILURE,
  payload: error,
});

export const updateArtistProfileRequest = (payload) => ({
  type: UPDATE_ARTIST_PROFILE_REQUEST,
  payload,
});

export const updateArtistProfileSuccess = (profile) => ({
  type: UPDATE_ARTIST_PROFILE_SUCCESS,
  payload: profile,
});

export const updateArtistProfileFailure = (error) => ({
  type: UPDATE_ARTIST_PROFILE_FAILURE,
  payload: error,
});
